import React from "react";
import { FormControl, InputLabel, MenuItem, Select, ThemeProvider, createTheme } from "@mui/material";
import ChevronDownIcon from "../../assets/icons/ChevronDownIcon";
import colors from "../../themes/colors";
import useTranslation from "../../hooks/useTranslation";
import { dt } from "../../themes/redesignTokens";

type TableToolbarSelectProps = {
  label?: string;
  items?: { id: any; name: string }[];
  value?: any;
  onChange?: (id: any) => void;
  widthFull?: boolean;
};

const TableToolbarSelect = ({ label, items, value, onChange = () => { }, widthFull }: TableToolbarSelectProps) => {
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            border: `1px solid ${colors.secondary.gray40}`,
            color: value ? dt.blue : colors.secondary.gray100,
            width: widthFull ? "100%" : ""
          },
          input: {
            margin: "12px 0 0 -8px"
          }
        }
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: colors.secondary.gray70,
            fontSize: "12px",
            fontWeight: 400,
            margin: "12px 0 0 -8px"
          }
        }
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            width: widthFull ? "100%" : ""
          }
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: `${colors.secondary.gray100} !important`,
            stroke: `${colors.secondary.gray100} !important`,
            height: 12,
            width: 12,
            marginTop: 6
          }
        }
      }
    }
  });
  const { translate } = useTranslation("common");

  return (
    <ThemeProvider theme={theme}>
      <FormControl variant="outlined">
        <InputLabel shrink={true}>{label}</InputLabel>

        <Select
          displayEmpty
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
          IconComponent={ChevronDownIcon}
          sx={{ width: widthFull ? "100%" : "155px" }}
        >
          <MenuItem value="">{translate("all")}</MenuItem>
          {items?.map((x) => (
            <MenuItem key={x.id} value={x.id}>
              {x.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default TableToolbarSelect;